module.exports = __webpack_public_path__ + "media/images/illust/illust-case01-f15c9836d07519b54322469a73c4c58f.svg";